import {
  onFocusTracked,
  onPrivacyChange,
  privacyChoice,
  privacySignal,
  setPrivacy,
} from '../platform/analytics';
import { $ } from './dom';

/**
 * The visitor's side of analytics: a one-time "remember this device?" card, asked at a natural
 * moment (after the first finished focus session, or after a couple of minutes). Browsers that
 * send Global Privacy Control / Do Not Track are never asked. (There are no Settings switches.)
 */
const card = $('#privacyCard');
const ASK_AFTER_MS = 120_000;

const canAsk = () => privacyChoice().stats && privacyChoice().remember === 'ask' && !privacySignal();

function showCard() {
  if (!canAsk() || !card.hidden) return;
  card.hidden = false;
}

function answer(remember: boolean) {
  card.hidden = true;
  setPrivacy({ remember: remember ? 'yes' : 'no' });
}

export function initPrivacy() {
  onPrivacyChange(() => {
    if (!canAsk()) card.hidden = true;
  });
  $('#pcYes').addEventListener('click', () => answer(true));
  $('#pcNo').addEventListener('click', () => answer(false));
  onFocusTracked((k) => k === 'done' && showCard());
  setTimeout(showCard, ASK_AFTER_MS);
}
